// @flow

import moment from 'moment';
const { duration } = moment;

// TODO: obvious code deduplication

const declensionYears = (n: number) => ({
	'11': 'лет',
	'12': 'лет',
	'13': 'лет',
	'14': 'лет',
}[n] || {
	'1': 'год',
	'2': 'года',
	'3': 'года',
	'4': 'года',
}[n % 10] || 'лет');

const reprYears = n => n > 0 ? n + ' ' + declensionYears(n) : '';

const declensionMonths = (n: number) => ({
	'11': 'месяцев',
	'12': 'месяцев',
	'13': 'месяцев',
	'14': 'месяцев',
}[n] || {
	'1': 'месяц',
	'2': 'месяца',
	'3': 'месяца',
	'4': 'месяца',
}[n % 10] || 'месяцев');

const reprMonths = n => n > 0 ? n + ' ' + declensionMonths(n) : '';

const declensionDays = (n: number) => ({
	'11': 'дней',
	'12': 'дней',
	'13': 'дней',
	'14': 'дней',
}[n] || {
	'1': 'день',
	'2': 'дня',
	'3': 'дня',
	'4': 'дня',
}[n % 10] || 'дней');

const reprDays = n => n > 0 ? n + ' ' + declensionDays(n) : '';

const declensionHours = (n: number) => ({
	'11': 'часов',
	'12': 'часов',
	'13': 'часов',
	'14': 'часов',
}[n] || {
	'1': 'час',
	'2': 'часа',
	'3': 'часа',
	'4': 'часа',
}[n % 10] || 'часов');

const reprHours = n => n > 0 ? n + ' ' + declensionHours(n) : '';

const declensionMinutes = (n: number) => ({
	'11': 'минут',
	'12': 'минут',
	'13': 'минут',
	'14': 'минут',
}[n] || {
	'1': 'минута',
	'2': 'минуты',
	'3': 'минуты',
	'4': 'минуты',
}[n % 10] || 'минут');

const reprMinutes = n => n > 0 ? n + ' ' + declensionMinutes(n) : '';

const declensionSeconds = (n: number) => ({
	'11': 'секунд',
	'12': 'секунд',
	'13': 'секунд',
	'14': 'секунд',
}[n] || {
	'1': 'секунда',
	'2': 'секунды',
	'3': 'секунды',
	'4': 'секунды',
}[n % 10] || 'секунд');

const reprSeconds = n => n > 0 ? n + ' ' + declensionSeconds(n) : '';

export const durationHumanize = (d: duration) => d && [
	reprYears(d.years()),
	reprMonths(d.months()),
	reprDays(d.days()),
	reprHours(d.hours()),
	reprMinutes(d.minutes()),
	reprSeconds(d.seconds()),
].filter(Boolean).join(' ');

export type DurationOption = {
	text: string,
	value: duration,
};

export const durationToOption = (d: duration): DurationOption => ({
	text: durationHumanize(d),
	value: d,
});
